import { MasterdataFilter } from '../types/masterdata-entity-definition';

/** `key - name`, or just the key while the (nullable) name is missing. */
export function keyName(key: string, name: string | null | undefined): string {
  return name ? `${key} - ${name}` : key;
}

/** Active-only default filter for endpoints exposing an `active` filter field. */
export const ACTIVE_ONLY: MasterdataFilter[] = [
  { type: 'booleanIsTrue', name: 'active' },
];
